<template>
  <canvas id="confettiCanvas"></canvas>
</template>

<script>
import confetti from 'canvas-confetti';

// Canvas confetti exception: CSS custom properties can't be read by a
// <canvas> particle system, so the palette is hardcoded here. These four
// hex values mirror --al-primary, --al-orange, --al-success, and
// --al-primary-soft in src/assets/utilities.css and must be kept in sync
// if those tokens ever change.
const CONFETTI_PALETTE = ["#2d90eb", "#eb882d", "#10b981", "#d7eafe"];

export default {
  name: "ConfettiCanvas",
  methods: {
    launchConfetti() {
      // Explicit reduced-motion gate (in addition to disableForReducedMotion
      // below) so the no-op is obvious and testable without relying solely
      // on the library's internal handling of the media query.
      const prefersReducedMotion = typeof window !== "undefined"
        && window.matchMedia
        && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (prefersReducedMotion) return;

      const canvas = document.getElementById("confettiCanvas");
      const myConfetti = confetti.create(canvas, { resize: true, disableForReducedMotion: true });

      // Launch confetti from left and right sides
      myConfetti({
        particleCount: 100,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: CONFETTI_PALETTE,
      });
      myConfetti({
        particleCount: 100,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: CONFETTI_PALETTE,
      });

      // stop confetti
      setTimeout(() => {
        myConfetti.reset();
      }, 4000);
    }
  }
};
</script>

<style scoped>
#confettiCanvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
</style>